import React, { useState, useEffect, useRef, ChangeEvent } from 'react'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import { Checkbox, Popper, Button } from '@material-ui/core'

import TextField from '@material-ui/core/TextField'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { FilterOptionsState } from '@material-ui/lab'

import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import CheckBoxIcon from '@material-ui/icons/CheckBox'

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <CheckBoxIcon fontSize="small" />

const useStyles = makeStyles(() =>
  createStyles({
    input: {
      width: '100%'
    }
  })
)

type Props = {
  labelValue?: string | undefined
  multiple?: boolean
  data: string[] | number[]
  defaultValues?: (number | string)[]
  onChange: (value: any | any[]) => void
}

export default function AutocompleteComponent ({ labelValue, multiple = true, data, defaultValues, onChange }: Props): JSX.Element {
  const classes = useStyles()
  const timer = useRef(-1)
  const [values, setValues] = useState<(string | number)[]>(defaultValues || [])
  const [isOpen, setIsOpen] = useState(false)
  const placeHolderLabel = labelValue
  const names = data.map((name) => name)
  let filteredOptions: (string | number)[] = []

  const setIsOpenTimer = (isOpened: boolean) => {
    clearTimeout(timer.current)
    timer.current = window.setTimeout(() => {
      setIsOpen(isOpened)
    }, 200)
  }
  const handleChange = (event: ChangeEvent<{}>, newValue?:any) => {
    setValues(newValue)
    onChange(newValue)
  }

  useEffect(() => {
    setValues(defaultValues || [])
  }, [defaultValues])

  const MyPopper = function (props: any) {
    const addAllClick = () => {
      setValues(filteredOptions)
      onChange(filteredOptions as string[])
      setIsOpenTimer(false)
    }

    return (
      <Popper {...props}>
        <Button color="primary" onClick={addAllClick}>
          Adicionar todos
        </Button>
        {props.children}
      </Popper>
    )
  }

  return (
    <Autocomplete
      multiple={multiple}
      className={classes.input}
      filterOptions={(options: (string | number)[], state: FilterOptionsState<string>): (string | number)[] => {
        filteredOptions = []
        const { inputValue } = state
        if (!inputValue) {
          filteredOptions = options.slice(0, 100)
        } else {
          filteredOptions = options.filter((option) => String(option).toLowerCase().indexOf(inputValue) > -1).slice(0, 50)
        }

        return filteredOptions
      }}
      PopperComponent={MyPopper}
      onOpen={() => {
        setIsOpenTimer(true)
      }}
      onClose={() => {
        setIsOpenTimer(false)
      }}
      open={isOpen}
      clearOnBlur={false}
      clearOnEscape={false}
      options={names}
      value={values}
      onChange={handleChange}
      getOptionLabel={(option) => option as string}
      renderOption={(result, { selected }) => (
        <React.Fragment>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{ marginRight: 8 }}
            checked={selected}
          />
          {result}
        </React.Fragment>
      )}
      style={{ width: 'auto' }}
      renderInput={(params) => (
        <TextField
        {...params}
        variant="outlined"
        placeholder={`Digite um(a) ${placeHolderLabel}`}
        label={placeHolderLabel}
        />
      )}
    />
  )
}
